function switchImage(productId, imageSrc, sectionId, varantUrl) {
  $('#media-' + productId + ' img+img').attr('src', imageSrc);
  $(`#CardLink-${ sectionId }-${ productId }`).attr('href', varantUrl);
  // console.log(`${productId} switch product's img: ${imageSrc}`);
}

function openTab(event, tabName) {
  $('.tabcontent').hide();
  $('.tablinks').removeClass('active');
  $(`.tabcontent.${tabName}`).show();
  $(event.target).addClass('active');
}

function showMoreImages() {
  $('.product__media-wrapper').addClass('show-all');
  $('.product__media-show-more').hide();
}

function addFreeMonogram() {
  $('.btn-add-monogram').hide();
  $('.btn-add-monogram.remove').show();
  $('.product-form__buttons .inject').show(200);
  $('.monogram-image-container').show(200);
}

function removeFreeMonogram() {
  // refresh page to remove monogram
  location.reload();
}

/**
customized javascript in https://admin.shopify.com/store/zero-halliburton/apps/live-product-options

$('input[name="properties[Monogram]"]').on('change paste keyup', function() {
  const monogram = $(this).val();
  console.log(monogram);
  $('.monogram-text').text(monogram.toUpperCase());
});

$('input[name="properties[Monogram color]"]').change(function() {
  const monogram_color = $(this).val();
  const rgb_color = $(this).next('div.cl-po--swatch-color').css('background-color');
  console.log(monogram_color, rgb_color);
  $('.monogram-text').css('color', rgb_color);
});
*/



$(function() {
  const selectedVariant = $('input[name=Color]:checked').val();
  // console.log(`init color: ${selectedVariant}`);
  if (!selectedVariant) return;
  $(`li.product__media-item`).hide();
  $(`li.product__media-item[data-media-alt^='${selectedVariant}']`).show();
});

